// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {formatLocalizedTime} from 'Utils/time-utils';
import moment from 'moment';

function TeeSheetCard(props) {
    const {data} = props;

    return (
        <div
            className='table-group-card tee-sheets-card'
            data-testid='tee-sheet-card'
        >
            <div
                className='card-header'
                data-testid='card-header'
            >
                <div className='card-header-item cell-left'>
                    {formatLocalizedTime(moment(data.date, 'L'), {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                    })}
                </div>
                <div className='card-header-time not-name'>
                    {formatLocalizedTime(moment(data.time, 'LT'), {
                        hour: 'numeric',
                        minute: 'numeric'
                    })}
                </div>
                <div className='card-header-item cell-right'>
                    {data.course}
                </div>
            </div>
            <div>
                <div
                    className='card-header-labels'
                    data-testid='card-header-labels'
                >
                    <div className='card-header-item name'>
                        {'NAME'}
                    </div>
                    <div className='card-header-item not-name'>
                        {'TRANS'}
                    </div>
                    <div className='card-header-item not-name'>
                        {'HOLES'}
                    </div>
                    <div className='card-header-item not-name'>
                        {'HCP'}
                    </div>
                </div>
                <div
                    className='table-list'
                    data-testid='table-list'
                >
                    {
                        data.player.map((player, i) => (
                            <div
                                className='table-list-items'
                                data-testid='table-list-item'
                                key={i}
                            >
                                <div className='table-cell name'>
                                    {player.name}
                                </div>
                                <div className='table-cell not-name'>
                                    {player.trans}
                                </div>
                                <div className='table-cell not-name'>
                                    {player.holes}
                                </div>
                                <div className='table-cell not-name'>
                                    {player.handicap}
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

TeeSheetCard.propTypes = {
    data: PropTypes.object
};

export default TeeSheetCard;
